import { getImageURL } from "../../services/ImageService";

export function SectionCardHStack(props) {
    const backgroundImagePath = props.img ? getImageURL(props.img) : null;

    return (
        <div
            className={`z-30 flex col-span-full gap-8 md:gap-16 flex-wrap md:flex-nowrap ${
                props.className ? props.className : ""
            }`}
        >
            {props.img && (
                <div
                    className="rounded-4xl bg-center bg-cover w-full h-[24rem]"
                    style={{ backgroundImage: backgroundImagePath }}
                />
            )}
            <div className="w-full">
                <h3 className="mt-0 font-robotoCondensed leading-[1.2] font-semibold">
                    {props.title}
                </h3>
                <p className="text-lg font-regular">{props.text}</p>
            </div>
            {props.children && <div className="w-full">{props.children}</div>}
        </div>
    );
}
